import { HyperlinkedMediaProps } from 'libs/contentful/props';
import Media from 'components/shared/Media/Media';
import Link from '../Link/Link';

const MIN_IMAGE_HEIGHT = 20;

const HyperlinkedMedia = ({ link, image, targetHeight }: HyperlinkedMediaProps) => {
  let mediaImage = image;

  if (targetHeight != null) {
    // Safeguard to ensure the image height is not too small
    const adjustedTargetHeight = targetHeight >= MIN_IMAGE_HEIGHT ? targetHeight : MIN_IMAGE_HEIGHT;

    const aspectRatioWidth =
      image?.width && image?.height ? image.width * (adjustedTargetHeight / image.height) : adjustedTargetHeight;

    mediaImage = {
      ...image,
      height: adjustedTargetHeight,
      width: aspectRatioWidth,
    };
  }

  const media = <Media media={mediaImage} className="rounded-none" />;

  return link ? <Link href={link}>{media}</Link> : <>{media}</>;
};

export default HyperlinkedMedia;
